import { render, staticRenderFns } from "./InsightDemographics.vue?vue&type=template&id=69cba37b&scoped=true&"
import script from "./InsightDemographics.vue?vue&type=script&lang=js&"
export * from "./InsightDemographics.vue?vue&type=script&lang=js&"
import style0 from "./InsightDemographics.vue?vue&type=style&index=0&id=69cba37b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cba37b",
  null
  
)

export default component.exports